import { useCallback, useState } from 'react'
import { Container } from 'lucide-react'
import AdminScreenShell, { Tegel } from '@/components/AdminScreenShell'
import { adminAPI } from '@/lib/api'

const OK = '#61E294', WRN = '#FFB57A', ERR = '#FF5A5A'

export default function AdminContainersScreen() {
  const [d, setD] = useState(null)
  const load = useCallback(async () => {
    const r = await adminAPI.schermContainers(); setD(r.data)
  }, [])
  const containers = d?.containers ?? []
  const running = containers.filter(c => c.state === 'running').length
  const unhealthy = containers.filter(c => !c.healthy && c.state === 'running').length
  const gestopt = containers.filter(c => c.state !== 'running').length

  return (
    <AdminScreenShell title="Containers" subtitle="Docker-details per container"
                      icon={Container} refreshMs={15_000} onRefresh={load}>
      <div className="grid grid-cols-4 gap-3 mb-4">
        <Tegel label="Draaiend"  waarde={running} kleur={OK} groot />
        <Tegel label="Unhealthy" waarde={unhealthy}
               kleur={unhealthy ? WRN : OK} />
        <Tegel label="Gestopt"   waarde={gestopt}
               kleur={gestopt ? ERR : OK} />
        <Tegel label="Totaal"    waarde={containers.length} kleur="#B4FF39" />
      </div>

      <div className="rounded-[6px] border border-border bg-card p-4">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-muted-foreground border-b border-border/40">
              <th className="py-2">Naam</th>
              <th>State</th>
              <th>Uptime</th>
              <th>Image</th>
              <th>Poorten</th>
              <th>Netwerk</th>
            </tr>
          </thead>
          <tbody>
            {containers.length === 0 ? (
              <tr><td colSpan={6} className="py-4 text-muted-foreground text-center">
                Geen container-data (docker.sock niet bereikbaar?).
              </td></tr>
            ) : containers.map(c => {
              const kl = c.state !== 'running' ? ERR : c.healthy ? OK : WRN
              return (
                <tr key={c.name} className="border-b border-border/20 last:border-0">
                  <td className="py-2 font-semibold" style={{ color: kl }}>
                    <span className="h-2 w-2 rounded-full inline-block mr-2"
                          style={{ background: kl }} />
                    {c.name}
                  </td>
                  <td className="font-mono text-xs uppercase">{c.state}</td>
                  <td className="font-mono text-xs">{c.uptime}</td>
                  <td className="font-mono text-[11px] text-muted-foreground truncate max-w-[16rem]">
                    {c.image}
                  </td>
                  <td className="font-mono text-[11px]">
                    {c.ports?.length ? c.ports.join(', ') : '—'}
                  </td>
                  <td className="font-mono text-[11px] text-muted-foreground">{c.network_mode}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </AdminScreenShell>
  )
}
